import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção dos demais relatórios de médico). */
export type RequerimentoUnicoMedicoJob = ReportJob;
export type RequerimentoUnicoMedicoJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) do Requerimento Único (Médico). */
@Injectable({ providedIn: 'root' })
export class RequerimentoUnicoMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'requerimento-unico-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.requerimentoUnicoMedico;
}
